/**
 * Landing/FormalitiesSecurityGuidelines Route - React Router v7
 *
 * Routes: /guia-seguridad-compra-venta-coches, /guia-seguridad-compra-venta-motos
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import {withThirdPartiesParam} from '../../../hocs/withThirdPartiesParam.js'
import FormalitiesSecurityGuidelinesRaw from './index.js'
import {landingFormalitiesSecurityGuidelinesInitalProps} from './landingFormalitiesSecurityGuidelinesInitalProps.js'

import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const FormalitiesSecurityGuidelines = withThirdPartiesParam(FormalitiesSecurityGuidelinesRaw)

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`

  const routeInfo = {
    location: {
      pathname,
      search: url.search
    }
  }

  try {
    const initialProps = await landingFormalitiesSecurityGuidelinesInitalProps({routeInfo, context})
    return {...initialProps, __RR7__: true}
  } catch (error: unknown) {
    console.error('[RR7] FormalitiesSecurityGuidelines loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  return <FormalitiesSecurityGuidelines {...data} />
}

Component.displayName = 'FormalitiesSecurityGuidelinesRoute'
